// MFL / AG1 / OSC CM KPI data extracted from MFL_AG1_OSC_CM_Dashboard_Feb26.html

export const CIRCLE_OPTIONS = [
  { value: 'ALL', label: 'All Circles' },
  { value: 'HP', label: 'HP' },
  { value: 'JA', label: 'JA' },
  { value: 'KS', label: 'KS' },
  { value: 'UW', label: 'UW' },
];

export const MISC_CM_ALERTS = [
  {
    tone: 'red',
    title: 'OSC Availability Crisis - All 14 CMPs Below 99.95% Target',
    body: 'Zone avg 93.7%. Hapur worst at 78.9% - 1 in 5 small cells unavailable. OSC is the largest domain by site count (7,214) and its availability failure is zone-wide.',
  },
  {
    tone: 'orange',
    title: 'OSC SA Alarms: Catastrophic - Bareilly 7%, Meerut 8%',
    body: 'Zone avg 42% SA alarm closure vs 100% target. J&K circles (Srinagar 31%, Jammu 38%) also critical. None of the 14 CMPs reaches even 80%.',
  },
  {
    tone: 'yellow',
    title: 'MFL Energy Compliance: Zone avg 51% - Shimla worst at 18%',
    body: 'All 308 MFL sites have 100% availability but energy parameter compliance is the weak KPI pulling scores below threshold. Srinagar (80%) and Moradabad (82%) are best practice benchmarks.',
  },
  {
    tone: 'blue',
    title: 'AG1 Visibility Gap: Avg 39% monitored - Kangra 17%',
    body: '62 AG1 sites with very low Zabbix/NMS visibility. Kangra at 17% and Aligarh at 25% are nearly blind. All 62 sites in 7.5% penalty tier.',
  },
];

export const MISC_CM_DOMAIN_TILES = [
  {
    domain: 'MFL',
    icon: '',
    label: 'MFL - Main Feeder Links',
    sites: 308,
    cmps: 14,
    kpi1Label: 'Availability',
    kpi1Value: '100%',
    kpi1Status: 'ok',
    kpi2Label: 'Avg Energy KPI',
    kpi2Value: '51%',
    note: 'All 308 sites in 7.5% penalty. PM compliance: 98.7% zone-wide.',
    borderColor: '#3b82f6',
  },
  {
    domain: 'AG1',
    icon: '',
    label: 'AG1 - Aggregator Nodes Level 1',
    sites: 62,
    cmps: 11,
    kpi1Label: 'Availability',
    kpi1Value: '~100%',
    kpi1Status: 'ok',
    kpi2Label: 'Avg Visibility',
    kpi2Value: '29%',
    note: 'Small scope but 2 CMPs with consecutive PM misses. All in 7.5% penalty.',
    borderColor: '#ec4899',
  },
  {
    domain: 'OSC',
    icon: '',
    label: 'OSC - Outdoor Small Cells',
    sites: 7214,
    cmps: 14,
    cells: 11533,
    kpi1Label: 'Avg Availability',
    kpi1Value: '93.7%',
    kpi1Status: 'miss',
    kpi2Label: 'Avg SA Alarm Closure',
    kpi2Value: '42%',
    note: 'Largest domain. PM TECO rate: 52% - nearly half the universe unserviced.',
    borderColor: '#059669',
  },
];

// ================================================================
// MFL DOMAIN
// ================================================================
export const MISC_CM_MFL = {
  kpis: [
    { value: '100%', label: 'Avg MFL Availability', sub: '308 sites - 2 partial exceptions', tone: 'green' },
    { value: '51%', label: 'Zone Avg Energy KPI', sub: 'Shimla worst: 18% | Srinagar best: 80%', tone: 'red' },
    { value: '80.3%', label: 'Zone Avg KPI Score', sub: 'All CMPs below 99.5% \u2192 7.5% penalty', tone: 'red' },
    { value: '66%', label: 'Zone Avg Visibility %', sub: 'Muzaffarnagar lowest: 45.2%', tone: 'orange' },
    { value: '1', label: 'Consec 2-Month PM Miss', sub: 'Mandi - 1 site at risk', tone: 'red' },
    { value: '98.7%', label: 'PM Compliance (Feb\'26)', sub: '305/308 sites TECO\'d', tone: 'green' },
  ],

  table: [
    { cmp: 'Kangra', circle: 'HP', sites: 20, pm_curr: 20, pm_last: 19, consec2: 0, kpi_pct: 74.0, energy_pct: 35.0, avail_pct: 100.0, vis_pct: 77.5, pen_sites: 13, ok_sites: 7 },
    { cmp: 'Mandi', circle: 'HP', sites: 18, pm_curr: 17, pm_last: 16, consec2: 1, kpi_pct: 72.2, energy_pct: 33.3, avail_pct: 100.0, vis_pct: 77.8, pen_sites: 13, ok_sites: 5 },
    { cmp: 'Shimla', circle: 'HP', sites: 33, pm_curr: 33, pm_last: 27, consec2: 0, kpi_pct: 67.3, energy_pct: 18.2, avail_pct: 100.0, vis_pct: 73.5, pen_sites: 27, ok_sites: 6 },
    { cmp: 'Jammu', circle: 'JA', sites: 40, pm_curr: 40, pm_last: 40, consec2: 0, kpi_pct: 79.0, energy_pct: 47.5, avail_pct: 100.0, vis_pct: 75.5, pen_sites: 21, ok_sites: 19 },
    { cmp: 'Srinagar', circle: 'KS', sites: 30, pm_curr: 30, pm_last: 28, consec2: 0, kpi_pct: 92.0, energy_pct: 80.0, avail_pct: 100.0, vis_pct: 80.8, pen_sites: 6, ok_sites: 24 },
    { cmp: 'Agra', circle: 'UW', sites: 11, pm_curr: 11, pm_last: 9, consec2: 0, kpi_pct: 74.5, energy_pct: 36.4, avail_pct: 100.0, vis_pct: 54.5, pen_sites: 7, ok_sites: 4 },
    { cmp: 'Aligarh', circle: 'UW', sites: 24, pm_curr: 23, pm_last: 22, consec2: 0, kpi_pct: 84.2, energy_pct: 62.5, avail_pct: 100.0, vis_pct: 61.5, pen_sites: 10, ok_sites: 14 },
    { cmp: 'Bareilly', circle: 'UW', sites: 18, pm_curr: 18, pm_last: 15, consec2: 0, kpi_pct: 88.9, energy_pct: 72.2, avail_pct: 100.0, vis_pct: 61.1, pen_sites: 5, ok_sites: 13 },
    { cmp: 'Bijnor', circle: 'UW', sites: 16, pm_curr: 16, pm_last: 15, consec2: 0, kpi_pct: 80.0, energy_pct: 50.0, avail_pct: 100.0, vis_pct: 56.2, pen_sites: 8, ok_sites: 8 },
    { cmp: 'Etawah', circle: 'UW', sites: 30, pm_curr: 30, pm_last: 25, consec2: 0, kpi_pct: 84.0, energy_pct: 63.3, avail_pct: 99.87, vis_pct: 55.8, pen_sites: 11, ok_sites: 19 },
    { cmp: 'Hapur', circle: 'UW', sites: 14, pm_curr: 14, pm_last: 14, consec2: 0, kpi_pct: 80.0, energy_pct: 50.0, avail_pct: 100.0, vis_pct: 55.4, pen_sites: 7, ok_sites: 7 },
    { cmp: 'Meerut', circle: 'UW', sites: 11, pm_curr: 11, pm_last: 10, consec2: 0, kpi_pct: 78.2, energy_pct: 45.5, avail_pct: 100.0, vis_pct: 63.6, pen_sites: 6, ok_sites: 5 },
    { cmp: 'Moradabad', circle: 'UW', sites: 17, pm_curr: 17, pm_last: 15, consec2: 0, kpi_pct: 92.9, energy_pct: 82.4, avail_pct: 100.0, vis_pct: 63.2, pen_sites: 3, ok_sites: 14 },
    { cmp: 'Muzaffarnagar', circle: 'UW', sites: 26, pm_curr: 25, pm_last: 23, consec2: 0, kpi_pct: 77.3, energy_pct: 46.2, avail_pct: 99.9984, vis_pct: 45.2, pen_sites: 14, ok_sites: 12 },
  ],

  charts: {
    kpiScore: {
      // MFL KPI Score % by CMP - bar chart
      // labels and data derived from table rows; yMin: 50, yMax: 100
    },
    energy: {
      // Energy Compliance % by CMP - bar chart
      // colors: >=70 green, >=50 yellow, <50 red
    },
  },

  // MFL PM compliance chart (Feb'26 vs Dec'25 counts)
  pmChart: {
    // Grouped bar: Feb vs Dec PM counts from table pm_curr vs pm_last
  },

  // MFL Visibility % chart
  visChart: {
    // Bar chart: vis_pct per CMP; colors: >=70 green, >=55 yellow, <55 orange
  },

  // PM Compliance Trend: Jan'26 -> Feb'26
  pmTrend: {
    kpis: [
      { value: '93.3%', label: 'Jan\'26 Zone TECO', sub: '278 / 298 sites', tone: 'green' },
      { value: '95.5%', label: 'Feb\'26 Zone TECO', sub: '294 / 308 sites', tone: 'green' },
      { value: '+2.2pp', label: 'Month-on-Month Gain', sub: 'Agra & Shimla +18pp each', tone: 'green' },
      { value: '14', label: 'Still Outstanding Feb', sub: '3 actionable \u00b7 11 N/A (no WO)', tone: 'orange' },
      { value: '+10', label: 'Scope Expansion', sub: '298 \u2192 308 sites in Feb\'26', tone: 'blue' },
    ],
    charts: {
      trend: {
        labels: ['Agra', 'Aligarh', 'Bareilly', 'Bijnor', 'Etawah', 'Hapur', 'Jammu', 'Kangra', 'Mandi', 'Meerut', 'Moradabad', 'Muzaffarnagar', 'Shimla', 'Srinagar'],
        jan: [81.8, 91.7, 88.2, 93.8, 96.2, 100.0, 100.0, 95.0, 88.9, 100.0, 93.8, 92.0, 81.8, 100.0],
        feb: [100.0, 95.8, 94.4, 100.0, 86.7, 100.0, 97.5, 100.0, 94.4, 90.9, 94.1, 92.3, 100.0, 93.3],
      },
      delta: {
        labels: ['Agra', 'Aligarh', 'Bareilly', 'Bijnor', 'Etawah', 'Hapur', 'Jammu', 'Kangra', 'Mandi', 'Meerut', 'Moradabad', 'Muzaffarnagar', 'Shimla', 'Srinagar'],
        data: [18.2, 4.1, 6.2, 6.2, -9.5, 0.0, -2.5, 5.0, 5.5, -9.1, 0.3, 0.3, 18.2, -6.7],
      },
    },
    table: [
      { cmp: 'Agra', circle: 'UW', janDone: '9/11', janPct: 81.8, febTeco: '11/11', febPct: 100.0, delta: '+18.2pp' },
      { cmp: 'Aligarh', circle: 'UW', janDone: '22/24', janPct: 91.7, febTeco: '23/24', febPct: 95.8, delta: '+4.2pp', febNote: '1 WOCL\u2191' },
      { cmp: 'Bareilly', circle: 'UW', janDone: '15/17', janPct: 88.2, febTeco: '17/18', febPct: 94.4, delta: '+6.2pp', febNote: '+1N/A (+1)' },
      { cmp: 'Bijnor', circle: 'UW', janDone: '15/16', janPct: 93.8, febTeco: '16/16', febPct: 100.0, delta: '+6.2pp' },
      { cmp: 'Etawah', circle: 'UW', janDone: '25/26', janPct: 96.2, febTeco: '26/30', febPct: 86.7, delta: '-9.5pp', febNote: '+4N/A (+4)' },
      { cmp: 'Hapur', circle: 'UW', janDone: '14/14', janPct: 100.0, febTeco: '14/14', febPct: 100.0, delta: '\u2014' },
      { cmp: 'Jammu', circle: 'JA', janDone: '40/40', janPct: 100.0, febTeco: '39/40', febPct: 97.5, delta: '-2.5pp', febNote: '+1N/A' },
      { cmp: 'Kangra', circle: 'HP', janDone: '19/20', janPct: 95.0, febTeco: '20/20', febPct: 100.0, delta: '+5.0pp' },
      { cmp: 'Mandi', circle: 'HP', janDone: '16/18', janPct: 88.9, febTeco: '17/18', febPct: 94.4, delta: '+5.6pp', febNote: '1 pending' },
      { cmp: 'Meerut', circle: 'UW', janDone: '10/10', janPct: 100.0, febTeco: '10/11', febPct: 90.9, delta: '-9.1pp', febNote: '+1N/A (+1)' },
      { cmp: 'Moradabad', circle: 'UW', janDone: '15/16', janPct: 93.8, febTeco: '16/17', febPct: 94.1, delta: '+0.4pp', febNote: '+1N/A (+1)' },
      { cmp: 'Muzaffarnagar', circle: 'UW', janDone: '23/25', janPct: 92.0, febTeco: '24/26', febPct: 92.3, delta: '+0.3pp', febNote: '+1N/A, 1 pending (+1)' },
      { cmp: 'Shimla', circle: 'HP', janDone: '27/33', janPct: 81.8, febTeco: '33/33', febPct: 100.0, delta: '+18.2pp' },
      { cmp: 'Srinagar', circle: 'KS', janDone: '28/28', janPct: 100.0, febTeco: '28/30', febPct: 93.3, delta: '-6.7pp', febNote: '+2N/A (+2)' },
    ],
  },
};

// ================================================================
// AG1 DOMAIN
// ================================================================
export const MISC_CM_AG1 = {
  kpis: [
    { value: '~100%', label: 'Avg AG1 Availability', sub: 'Aligarh 1 site at 99.93% - rest 100%', tone: 'green' },
    { value: '25%', label: 'Zone Avg Energy KPI', sub: 'Worse than MFL. Bareilly best: 87.5%', tone: 'red' },
    { value: '67.8%', label: 'Zone Avg KPI Score', sub: 'Worse than MFL\'s 80.3%', tone: 'red' },
    { value: '37.3%', label: 'Zone Avg Visibility', sub: 'Kangra worst: 16.7% - near blind', tone: 'red' },
    { value: '2', label: 'Consec 2-Month PM Miss', sub: 'Kangra + Meerut', tone: 'orange' },
    { value: '95.2%', label: 'PM Compliance (Feb\'26)', sub: '59/62 sites TECO\'d', tone: 'green' },
  ],

  table: [
    { cmp: 'Kangra', circle: 'HP', sites: 2, pm_curr: 1, pm_last: 1, consec2: 1, kpi_pct: 50.0, energy_pct: 0.0, avail_pct: 100.0, vis_pct: 16.7, pen_sites: 2, ok_sites: 0 },
    { cmp: 'Shimla', circle: 'HP', sites: 6, pm_curr: 6, pm_last: 6, consec2: 0, kpi_pct: 66.7, energy_pct: 16.7, avail_pct: 100.0, vis_pct: 61.1, pen_sites: 5, ok_sites: 1 },
    { cmp: 'Jammu', circle: 'JA', sites: 9, pm_curr: 9, pm_last: 8, consec2: 0, kpi_pct: 64.4, energy_pct: 11.1, avail_pct: 100.0, vis_pct: 58.6, pen_sites: 8, ok_sites: 1 },
    { cmp: 'Srinagar', circle: 'KS', sites: 4, pm_curr: 4, pm_last: 4, consec2: 0, kpi_pct: 70.0, energy_pct: 25.0, avail_pct: 100.0, vis_pct: 75.0, pen_sites: 3, ok_sites: 1 },
    { cmp: 'Agra', circle: 'UW', sites: 8, pm_curr: 7, pm_last: 8, consec2: 0, kpi_pct: 62.5, energy_pct: 12.5, avail_pct: 100.0, vis_pct: 33.3, pen_sites: 7, ok_sites: 1 },
    { cmp: 'Aligarh', circle: 'UW', sites: 4, pm_curr: 4, pm_last: 4, consec2: 0, kpi_pct: 60.0, energy_pct: 25.0, avail_pct: 99.93, vis_pct: 25.0, pen_sites: 3, ok_sites: 1 },
    { cmp: 'Bareilly', circle: 'UW', sites: 8, pm_curr: 8, pm_last: 7, consec2: 0, kpi_pct: 95.0, energy_pct: 87.5, avail_pct: 100.0, vis_pct: 33.3, pen_sites: 1, ok_sites: 7 },
    { cmp: 'Etawah', circle: 'UW', sites: 1, pm_curr: 1, pm_last: 1, consec2: 0, kpi_pct: 60.0, energy_pct: 0.0, avail_pct: 100.0, vis_pct: 0.0, pen_sites: 1, ok_sites: 0 },
    { cmp: 'Meerut', circle: 'UW', sites: 10, pm_curr: 9, pm_last: 7, consec2: 1, kpi_pct: 74.0, energy_pct: 40.0, avail_pct: 100.0, vis_pct: 33.3, pen_sites: 6, ok_sites: 4 },
    { cmp: 'Moradabad', circle: 'UW', sites: 3, pm_curr: 3, pm_last: 2, consec2: 0, kpi_pct: 60.0, energy_pct: 0.0, avail_pct: 100.0, vis_pct: 44.4, pen_sites: 3, ok_sites: 0 },
    { cmp: 'Muzaffarnagar', circle: 'UW', sites: 7, pm_curr: 7, pm_last: 7, consec2: 0, kpi_pct: 82.9, energy_pct: 57.1, avail_pct: 100.0, vis_pct: 28.6, pen_sites: 3, ok_sites: 4 },
  ],

  charts: {
    kpiScore: {
      // AG1 KPI Score % by CMP - bar chart; yMin: 40, yMax: 100
    },
    energy: {
      // AG1 Energy Compliance % by CMP - bar chart
      // colors: >=70 green, >=30 yellow, <30 red
    },
  },

  // AG1 PM Compliance Trend: Jan'26 -> Feb'26
  pmTrend: {
    kpis: [
      { value: '88.7%', label: 'Jan\'26 Zone TECO', sub: '55 / 62 sites', tone: 'orange' },
      { value: '95.2%', label: 'Feb\'26 Zone TECO', sub: '59 / 62 sites', tone: 'green' },
      { value: '\u25b2 6.5pp', label: 'Month-on-Month Change', sub: 'Moradabad best +33.3pp', tone: 'green' },
      { value: '3', label: 'Outstanding Feb\'26', sub: 'Agra 1 \u00b7 Kangra 1 \u00b7 Meerut 1', tone: 'green' },
      { value: '3', label: 'Improved CMPs', sub: 'Bareilly, Jammu, Meerut, Moradabad', tone: 'green' },
    ],
    charts: {
      trend: {
        labels: ['Agra', 'Aligarh', 'Bareilly', 'Etawah', 'Jammu', 'Kangra', 'Meerut', 'Moradabad', 'Muzaffarnagar', 'Shimla', 'Srinagar'],
        jan: [100.0, 100.0, 87.5, 100.0, 88.9, 50.0, 70.0, 66.7, 100.0, 100.0, 100.0],
        feb: [87.5, 100.0, 100.0, 100.0, 100.0, 50.0, 90.0, 100.0, 100.0, 100.0, 100.0],
        febColors: ['#f59e0b80', '#f59e0b80', '#f59e0b80', '#f59e0b80', '#ef444480', '#3b82f680', '#f59e0b80', '#f59e0b80', '#f59e0b80', '#3b82f680', '#8b5cf680'],
        febBorders: ['#f59e0b', '#f59e0b', '#f59e0b', '#f59e0b', '#ef4444', '#3b82f6', '#f59e0b', '#f59e0b', '#f59e0b', '#3b82f6', '#8b5cf6'],
      },
      delta: {
        labels: ['Agra', 'Aligarh', 'Bareilly', 'Etawah', 'Jammu', 'Kangra', 'Meerut', 'Moradabad', 'Muzaffarnagar', 'Shimla', 'Srinagar'],
        data: [-12.5, 0.0, 12.5, 0.0, 11.1, 0.0, 20.0, 33.3, 0.0, 0.0, 0.0],
      },
    },
    table: [
      { cmp: 'Agra', circle: 'UW', janDone: '8/8', janPct: 100.0, febDone: '7/8', febPct: 87.5, delta: '-12.5pp' },
      { cmp: 'Aligarh', circle: 'UW', janDone: '4/4', janPct: 100.0, febDone: '4/4', febPct: 100.0, delta: '\u2014' },
      { cmp: 'Bareilly', circle: 'UW', janDone: '7/8', janPct: 87.5, febDone: '8/8', febPct: 100.0, delta: '+12.5pp' },
      { cmp: 'Etawah', circle: 'UW', janDone: '1/1', janPct: 100.0, febDone: '1/1', febPct: 100.0, delta: '\u2014' },
      { cmp: 'Jammu', circle: 'JA', janDone: '8/9', janPct: 88.9, febDone: '9/9', febPct: 100.0, delta: '+11.1pp' },
      { cmp: 'Kangra', circle: 'HP', janDone: '1/2', janPct: 50.0, febDone: '1/2', febPct: 50.0, delta: '\u2014' },
      { cmp: 'Meerut', circle: 'UW', janDone: '7/10', janPct: 70.0, febDone: '9/10', febPct: 90.0, delta: '+20.0pp' },
      { cmp: 'Moradabad', circle: 'UW', janDone: '2/3', janPct: 66.7, febDone: '3/3', febPct: 100.0, delta: '+33.3pp' },
      { cmp: 'Muzaffarnagar', circle: 'UW', janDone: '7/7', janPct: 100.0, febDone: '7/7', febPct: 100.0, delta: '\u2014' },
      { cmp: 'Shimla', circle: 'HP', janDone: '6/6', janPct: 100.0, febDone: '6/6', febPct: 100.0, delta: '\u2014' },
      { cmp: 'Srinagar', circle: 'KS', janDone: '4/4', janPct: 100.0, febDone: '4/4', febPct: 100.0, delta: '\u2014' },
    ],
  },
};

// ================================================================
// OSC DOMAIN
// ================================================================
export const MISC_CM_OSC = {
  kpis: [
    { value: '93.7%', label: 'Zone Avg Availability (Target >99.95%)', sub: 'Hapur worst: 78.9% | Meerut best: 98.3%', tone: 'red' },
    { value: '42%', label: 'Zone Avg SA Alarm Closure (Target 100%)', sub: 'Bareilly 7% - catastrophic', tone: 'red' },
    { value: '2,226', label: 'Total SMPS Unreachable Cases', sub: 'Shimla 294, Bareilly 211 highest', tone: 'orange' },
    { value: '44', label: 'Total UBR RSL Degraded Cases', sub: 'Srinagar 6, Shimla 4 highest', tone: 'yellow' },
    { value: '52%', label: 'Zone PM TECO Rate', sub: 'Hapur worst: 34.3% | Shimla best: 82.1%', tone: 'red' },
    { value: '44', label: 'Total UBR Port Speed Cases', sub: 'Hapur 11, Etawah 7, Aligarh 7', tone: 'orange' },
  ],

  table: [
    { cmp: 'Kangra', circle: 'HP', sites: 356, cells: 643, pm_teco: 224, pm_pct: 62.9, avail: 98.386, sa: 78.0, ubr_rsl: 1, smps: 136, ubr_port: 0 },
    { cmp: 'Mandi', circle: 'HP', sites: 290, cells: 538, pm_teco: 220, pm_pct: 75.9, avail: 95.065, sa: 79.0, ubr_rsl: 0, smps: 150, ubr_port: 2 },
    { cmp: 'Shimla', circle: 'HP', sites: 476, cells: 947, pm_teco: 391, pm_pct: 82.1, avail: 97.399, sa: 77.0, ubr_rsl: 4, smps: 294, ubr_port: 1 },
    { cmp: 'Jammu', circle: 'JA', sites: 451, cells: 941, pm_teco: 319, pm_pct: 70.7, avail: 94.852, sa: 38.0, ubr_rsl: 1, smps: 134, ubr_port: 4 },
    { cmp: 'Srinagar', circle: 'KS', sites: 518, cells: 1026, pm_teco: 274, pm_pct: 52.9, avail: 95.355, sa: 31.0, ubr_rsl: 6, smps: 175, ubr_port: 0 },
    { cmp: 'Agra', circle: 'UW', sites: 406, cells: 771, pm_teco: 173, pm_pct: 42.6, avail: 96.142, sa: 59.0, ubr_rsl: 2, smps: 126, ubr_port: 4 },
    { cmp: 'Aligarh', circle: 'UW', sites: 758, cells: 1386, pm_teco: 327, pm_pct: 43.1, avail: 90.013, sa: 21.0, ubr_rsl: 2, smps: 162, ubr_port: 7 },
    { cmp: 'Bareilly', circle: 'UW', sites: 720, cells: 1231, pm_teco: 292, pm_pct: 40.6, avail: 87.856, sa: 7.0, ubr_rsl: 1, smps: 211, ubr_port: 3 },
    { cmp: 'Bijnor', circle: 'UW', sites: 443, cells: 868, pm_teco: 201, pm_pct: 45.4, avail: 92.342, sa: 43.0, ubr_rsl: 0, smps: 117, ubr_port: 1 },
    { cmp: 'Etawah', circle: 'UW', sites: 679, cells: 1217, pm_teco: 267, pm_pct: 39.3, avail: 89.277, sa: 18.0, ubr_rsl: 1, smps: 188, ubr_port: 7 },
    { cmp: 'Hapur', circle: 'UW', sites: 508, cells: 1020, pm_teco: 174, pm_pct: 34.3, avail: 78.879, sa: 49.0, ubr_rsl: 3, smps: 117, ubr_port: 11 },
    { cmp: 'Meerut', circle: 'UW', sites: 307, cells: 636, pm_teco: 120, pm_pct: 39.1, avail: 98.274, sa: 8.0, ubr_rsl: 0, smps: 37, ubr_port: 0 },
    { cmp: 'Moradabad', circle: 'UW', sites: 667, cells: 1266, pm_teco: 286, pm_pct: 42.9, avail: 93.990, sa: 34.0, ubr_rsl: 0, smps: 154, ubr_port: 2 },
    { cmp: 'Muzaffarnagar', circle: 'UW', sites: 635, cells: 1250, pm_teco: 259, pm_pct: 40.8, avail: 93.838, sa: 72.0, ubr_rsl: 3, smps: 124, ubr_port: 2 },
  ],

  charts: {
    availability: {
      // OSC Availability % by CMP - bar; yMin: 70, yMax: 100
      // colors: >=99.95 green, >=95 yellow, >=90 orange, <90 red
    },
    saAlarm: {
      // OSC SA Alarm Closure % by CMP - bar; yMin: 0, yMax: 100
      // colors: >=80 green, >=50 yellow, >=30 orange, <30 red
    },
    pmTeco: {
      // OSC PM TECO Rate by CMP - bar; yMin: 0, yMax: 100
      // colors: >=70 green, >=50 yellow, <50 orange
    },
    smps: {
      // SMPS Unreachable Cases by CMP - bar; circle colors
    },
  },

  // OSC PM Compliance Snapshot (Feb'26 only - Jan'26 not available)
  pmSnapshot: {
    kpis: [
      { value: '48.9%', label: 'Feb\'26 Zone TECO', sub: '3,527 / 7,214 sites', tone: 'orange' },
      { value: '3,687', label: 'Outstanding Feb\'26', sub: 'PM not TECO\'d yet', tone: 'red' },
      { value: '82.1%', label: 'Best CMP \u2014 Shimla', sub: '391/476 sites', tone: 'green' },
      { value: '34.3%', label: 'Worst CMP \u2014 Hapur', sub: '174/508 sites', tone: 'red' },
      { value: '74.4%', label: 'HP Circle (Best)', sub: 'vs UW 41.0% & JA 70.7%', tone: 'green' },
    ],
    charts: {
      trend: {
        labels: ['Agra', 'Aligarh', 'Bareilly', 'Bijnor', 'Etawah', 'Hapur', 'Jammu', 'Kangra', 'Mandi', 'Meerut', 'Moradabad', 'Muzaffarnagar', 'Shimla', 'Srinagar'],
        feb: [42.6, 43.1, 40.6, 45.4, 39.3, 34.3, 70.7, 62.9, 75.9, 39.1, 42.9, 40.8, 82.1, 52.9],
        colors: ['#f59e0b80', '#f59e0b80', '#f59e0b80', '#f59e0b80', '#f59e0b80', '#f59e0b80', '#ef444480', '#3b82f680', '#3b82f680', '#f59e0b80', '#f59e0b80', '#f59e0b80', '#3b82f680', '#8b5cf680'],
        borders: ['#f59e0b', '#f59e0b', '#f59e0b', '#f59e0b', '#f59e0b', '#f59e0b', '#ef4444', '#3b82f6', '#3b82f6', '#f59e0b', '#f59e0b', '#f59e0b', '#3b82f6', '#8b5cf6'],
      },
      circle: {
        labels: ['HP', 'JA', 'KS', 'UW'],
        data: [74.4, 70.7, 52.9, 41.0],
        colors: ['#3b82f680', '#ef444480', '#8b5cf680', '#f59e0b80'],
        borders: ['#3b82f6', '#ef4444', '#8b5cf6', '#f59e0b'],
      },
    },
    table: [
      { cmp: 'Agra', circle: 'UW', doneScope: '173/406', tecoPct: 42.6, outstanding: 233 },
      { cmp: 'Aligarh', circle: 'UW', doneScope: '327/758', tecoPct: 43.1, outstanding: 431 },
      { cmp: 'Bareilly', circle: 'UW', doneScope: '292/720', tecoPct: 40.6, outstanding: 428 },
      { cmp: 'Bijnor', circle: 'UW', doneScope: '201/443', tecoPct: 45.4, outstanding: 242 },
      { cmp: 'Etawah', circle: 'UW', doneScope: '267/679', tecoPct: 39.3, outstanding: 412 },
      { cmp: 'Hapur', circle: 'UW', doneScope: '174/508', tecoPct: 34.3, outstanding: 334 },
      { cmp: 'Jammu', circle: 'JA', doneScope: '319/451', tecoPct: 70.7, outstanding: 132 },
      { cmp: 'Kangra', circle: 'HP', doneScope: '224/356', tecoPct: 62.9, outstanding: 132 },
      { cmp: 'Mandi', circle: 'HP', doneScope: '220/290', tecoPct: 75.9, outstanding: 70 },
      { cmp: 'Meerut', circle: 'UW', doneScope: '120/307', tecoPct: 39.1, outstanding: 187 },
      { cmp: 'Moradabad', circle: 'UW', doneScope: '286/667', tecoPct: 42.9, outstanding: 381 },
      { cmp: 'Muzaffarnagar', circle: 'UW', doneScope: '259/635', tecoPct: 40.8, outstanding: 376 },
      { cmp: 'Shimla', circle: 'HP', doneScope: '391/476', tecoPct: 82.1, outstanding: 85 },
      { cmp: 'Srinagar', circle: 'KS', doneScope: '274/518', tecoPct: 52.9, outstanding: 244 },
    ],
  },
};

// ================================================================
// INSIGHTS
// ================================================================
export const MISC_CM_INSIGHT_CHIPS = [
  '3 Domains',
  '7,584 Sites',
  '5 Key Findings',
];

export const MISC_CM_INSIGHTS = [
  {
    tone: 'red',
    title: 'OSC Availability: The Largest Active KPI Failure in the Zone',
    exposure: 'OSC KPI 6.1 | Target >99.95% | Zone avg 93.7% | 7,214 sites affected | Hapur 78.9% \u2014 worst',
    body: 'Unlike MFL and AG1 where availability is near-perfect, the OSC domain has a zone-wide availability collapse. The 99.95% target means small cells should be down for fewer than 26 minutes per month \u2014 the current zone average of 93.7% means they\'re down roughly 45 hours per month on average. Hapur at 78.9% implies its small cells are unavailable for nearly 150 hours per month \u2014 effectively non-functional. Bareilly (87.9%), Etawah (89.3%), and Aligarh (90.0%) are also critically low. The root cause is almost certainly a combination of power supply failures at outdoor sites and backhaul connectivity issues. SMPS unreachable cases correlate with availability failures \u2014 Bareilly has 211 SMPS issues and 87.9% availability; Shimla has 294 SMPS issues. OSC sites are power-dependent outdoor units and any SMPS failure immediately takes the site down.',
    metrics: [
      { value: '93.7%', label: 'Zone avg (target 99.95%)', tone: 'red' },
      { value: '78.9%', label: 'Hapur \u2014 worst CMP', tone: 'red' },
      { value: '2,226', label: 'SMPS unreachable cases', tone: 'orange' },
    ],
    actionTitle: 'Action',
    action: 'Emergency SMPS health audit across all 7,214 OSC sites \u2014 prioritise Bareilly (211 SMPS issues), Shimla (294), Etawah (188), Hapur (117). Each SMPS failure = site down. Fix power supply connectivity first, then assess actual radio unit health. Hapur (78.9% avail) and Bareilly (87.9%) need escalation to Circle Head. Owner: UW + HP Circle Ops + NMS Team.',
  },
  {
    tone: 'orange',
    title: 'OSC SA Alarms: The Same NOC Process Failure \u2014 But Worse Than Tower',
    exposure: 'OSC KPI 6.2 | Zone avg 42% | Bareilly 7% \u2014 worst in entire North Zone across all domains',
    body: 'Tower CM SA alarm closure zone-averaged 74.9% \u2014 bad, but OSC averages just 42%. Bareilly\'s 7% and Meerut\'s 8% are extraordinary failures \u2014 93% of SA alarms on OSC sites are not being closed within 4 hours. This is almost certainly because small cell alarms are lower priority in NOC queues and lack the same escalation visibility as macro tower alarms. The J&K circles (Srinagar 31%, Jammu 38%) are also alarming given the geo-strategic importance of these sites. Critically, this is a purely NOC-side problem \u2014 no field action is required to close alarms within the 4-hour SLA if alarm management workflows are functioning. The fact that Muzaffarnagar (72%) and Kangra (78%) are significantly better suggests the gap is CMP-level NOC discipline, not a systemic Jio tool failure.',
    metrics: [
      { value: '42%', label: 'Zone avg (target 100%)', tone: 'red' },
      { value: '7%', label: 'Bareilly \u2014 worst', tone: 'red' },
      { value: '78%', label: 'Kangra \u2014 best practice', tone: 'green' },
    ],
    actionTitle: 'Action',
    action: 'Dedicated OSC alarm queue in NOC tool \u2014 small cell alarms must be triaged separately from macro alarms or they\'ll always deprioritised. Kangra (78%) and Muzaffarnagar (72%) have figured this out \u2014 replicate their process. Bareilly (7%) and Meerut (8%) NOC teams need immediate review. Zero-cost fix. Owner: NOC Manager \u2014 no field dependency.',
  },
  {
    tone: 'blue',
    title: 'MFL/AG1 Energy Compliance: Structural Monitoring Gap, Not Field Failure',
    exposure: 'MFL KPI | Zone avg 51% energy compliance | AG1 even worse: 25% | Shimla MFL: 18%, Kangra AG1: 0%',
    body: 'Both MFL and AG1 show near-perfect availability (100%) \u2014 meaning the physical sites are operational. The KPI drag is entirely from energy parameter compliance, which measures whether EB (mains power), DG energy, and total kWh readings are within valid bounds. When a site\'s energy readings are outside expected ranges (e.g., zero EB but non-zero DG, or extremely high/low kWh) it fails the energy KPI. A 51% energy compliance rate zone-wide means roughly half the MFL sites are either reporting invalid energy data or genuinely have energy irregularities. This is most likely a data quality problem \u2014 sensors not reporting, NMS connectivity to energy meters broken, or energy parameter thresholds set incorrectly \u2014 rather than actual power failures (since availability is 100%). Shimla at 18% is particularly striking given 100% availability \u2014 the sites are clearly running but energy telemetry is broken.',
    metrics: [
      { value: '51%', label: 'MFL energy KPI avg', tone: 'orange' },
      { value: '25%', label: 'AG1 energy KPI avg', tone: 'red' },
      { value: '80%+', label: 'Srinagar/Moradabad best', tone: 'green' },
    ],
    actionTitle: 'Action',
    action: 'Energy sensor audit for MFL and AG1 \u2014 check NMS connectivity for energy meters at Shimla (18%), Kangra MFL (35%), Mandi (33%). Cross-reference with actual site energy bills to confirm whether the issue is sensor/NMS or genuine energy anomaly. Srinagar (80%) and Moradabad (82%) should share their energy monitoring configuration as a template. Owner: NMS + Energy Team.',
  },
  {
    tone: 'purple',
    title: 'OSC PM TECO Rate at 52% \u2014 Half the Small Cell Universe Unserviced',
    exposure: 'OSC PM | 3,741/7,214 sites with PM TECO | Hapur 34.3% \u2014 worst | Shimla 82.1% \u2014 best',
    body: 'The OSC PM completion rate of 52% means 3,473 small cell sites had no completed PM in Feb\'26. For a domain where availability is already critically low (93.7%), this creates a reinforcing failure loop: sites are poorly maintained \u2192 more failures \u2192 availability drops further. Hapur (34.3%), Srinagar (52.9%), and Meerut (39.1%) are the worst offenders. HP circle CMPs (Shimla 82.1%, Mandi 75.9%) are significantly better, suggesting that either resource availability or prioritisation is better managed in HP. It\'s worth noting that OSC sites (outdoor small cells) may have access constraints compared to tower sites, but the Shimla/Mandi performance shows this is achievable. The low PM TECO rate will directly feed into PM penalty deductions on top of CM KPI penalties.',
    metrics: [
      { value: '52%', label: 'Zone PM TECO rate', tone: 'red' },
      { value: '3,473', label: 'Sites without PM (Feb\'26)', tone: 'red' },
      { value: '82.1%', label: 'Shimla \u2014 benchmark', tone: 'green' },
    ],
    actionTitle: 'Action',
    action: 'Escalate OSC PM completion as a standalone initiative \u2014 it\'s being treated as lower priority than tower PM. Hapur (34%), Meerut (39%), Etawah (39%) need dedicated resource allocation for small cell PM teams. Use Shimla (82%) PM methodology as the standard. Target: get all CMPs above 65% TECO rate by Mar\'26. Owner: Circle Ops + PM Scheduling Team.',
  },
  {
    tone: 'green',
    title: 'MFL Availability: The One Bright Spot \u2014 100% Across 308 Sites',
    exposure: 'MFL KPI | 308/308 sites \u226599.85% availability | 2 sites with minor exceptions \u2014 Etawah & Muzaffarnagar',
    body: 'Against a backdrop of availability failures in OSC and energy failures in MFL/AG1, the MFL domain\'s 100% availability record across 308 sites is the single clean result in this dashboard. Fronthaul links are mission-critical \u2014 if an MFL link goes down, the macro tower it feeds loses backhaul, which multiplies the impact across the tower CM KPIs as well. The fact that all 14 CMPs are maintaining fronthaul uptime is important. The only two exceptions are Etawah (one site at 99.87%) and Muzaffarnagar (one site at 99.9984%) \u2014 both marginal and both still in penalty on availability. The focus for MFL improvement is therefore entirely on the energy compliance side, not field infrastructure recovery.',
    metrics: [
      { value: '308/308', label: 'Sites \u226599.85% avail', tone: 'green' },
      { value: '98.7%', label: 'PM compliance rate', tone: 'green' },
      { value: '51%', label: 'Energy KPI \u2014 key gap', tone: 'orange' },
    ],
    actionTitle: 'Action',
    action: 'MFL is field-stable \u2014 no emergency field work needed. Shift focus entirely to energy parameter data quality. Audit energy sensor configurations at the 150+ sites with zero energy readings. Srinagar\'s 80% energy compliance is evidence this is solvable within the existing infrastructure. Owner: NMS Data Quality + Circle Teams.',
  },
];

// ================================================================
// ACTION PLAN
// ================================================================
export const MISC_CM_ACTIONS = [
  {
    priority: 'P1',
    domain: 'OSC',
    action: 'Emergency SMPS audit for offline/unreachable units',
    detail: '2,226 SMPS unreachable cases zone-wide directly correlate with availability failures. Fix NMS connectivity for offline SMPS units before investigating radio hardware. No field visit required for NMS connectivity fix.',
    cmps: 'Bareilly (211), Shimla (294), Etawah (188), Hapur (117)',
    owner: 'NMS + Circle Ops',
    impact: 'Each SMPS connectivity fix can restore site availability. Direct path to improving OSC KPI 6.1 from 93.7% zone avg.',
  },
  {
    priority: 'P1',
    domain: 'OSC',
    action: 'Dedicated OSC alarm queue in NOC',
    detail: 'SA alarm closure at 42% zone avg (Bareilly 7%, Meerut 8%) is a NOC process failure. Create a separate small cell alarm triage queue with 4-hour SLA alerts. Replicate Kangra (78%) process across all CMPs.',
    cmps: 'Bareilly, Meerut, Etawah, Aligarh',
    owner: 'NOC Manager',
    impact: 'Zero cost. Each CMP reaching 80%+ closure earns KPI points. Kangra already there \u2014 process proven.',
  },
  {
    priority: 'P1',
    domain: 'OSC',
    action: 'Hapur OSC emergency intervention',
    detail: '78.9% availability (worst in zone), 34.3% PM TECO, 117 SMPS issues. Multi-failure CMP. 508 small cell sites in severe degradation. Requires Circle Head escalation and dedicated field taskforce.',
    cmps: 'Hapur',
    owner: 'UW Circle Head',
    impact: 'Currently most exposed CMP across all three domains. Closing to 90% avail recovers significant KPI score.',
  },
  {
    priority: 'P2',
    domain: 'MFL, AG1',
    action: 'Energy sensor / NMS connectivity audit',
    detail: 'MFL zone avg 51% energy KPI, AG1 avg 25%. Sites with 100% availability but 0% energy compliance have broken energy telemetry, not actual energy failures. Audit Shimla MFL (18%), Kangra AG1 (0%), Mandi MFL (33%).',
    cmps: 'Shimla, Kangra, Mandi (priority)',
    owner: 'NMS Data Team',
    impact: 'Fixing energy KPI can move CMPs from 7.5% to lower penalty tiers. Srinagar (80%) proves it\'s achievable.',
  },
  {
    priority: 'P2',
    domain: 'OSC',
    action: 'OSC PM completion drive \u2014 target all CMPs above 65% TECO',
    detail: 'Zone at 52%, with 3,473 sites unserviced. Hapur (34%), Meerut (39%), Etawah (39%), Muzaffarnagar (41%) most behind. HP circle benchmark (Shimla 82%, Mandi 76%) shows this is achievable.',
    cmps: 'Hapur, Meerut, Etawah, Muzaffarnagar, Srinagar',
    owner: 'PM Scheduling',
    impact: 'Completed PMs reduce repeat failures, improving availability KPI in next billing cycle.',
  },
  {
    priority: 'P3',
    domain: 'AG1',
    action: 'AG1 visibility uplift \u2014 target >50% monitored',
    detail: 'Zone avg 39% visibility. Kangra at 17% and Aligarh at 25% are nearly blind to NMS monitoring. Also fix 2 consecutive PM miss sites (Kangra + Meerut) before they trigger 2\u00d7 penalty deduction. Zone avg visibility corrected to 37.3%.',
    cmps: 'Kangra, Aligarh, Meerut',
    owner: 'NMS Team',
    impact: 'Better visibility = earlier fault detection = better availability scores in subsequent months.',
  },
];

// ================================================================
// RECOVERABLE BANNER
// ================================================================
export const MISC_CM_RECOVERABLE_BANNER = 'Fix OSC SMPS + SA Alarms \u2192 availability recovery | Fix MFL/AG1 energy telemetry \u2192 KPI tier improvement | Hapur OSC = #1 priority';

// ================================================================
// CIRCLE COLORS (for chart rendering)
// ================================================================
export const MISC_CIRCLE_COLORS = { HP: '#3b82f6', JA: '#ef4444', KS: '#8b5cf6', UW: '#f59e0b' };
